import React, { Component, useReducer } from 'react';
import {Collapse,Nav,Navfitness_plan,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, Dropdownfitness_plan, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'
import StripeCheckout from './stripe_checkout'


class FitnessPlan extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
        super(props);
        this.state = {
            fitness_plan: {},
            loading: true
        };
        this.HandleChange = (e) =>{
            this.setState({[e.target.name]: e.target.value});
        };

        this.ProgramPurchaseSuccessful = (amount) => {
          this.setState({loading: true})
            const { cookies } = this.props;

            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('trainer_id', this.state.fitness_plan.uploader_id)
            data.append('amount', amount)

            axios.post(Backend_Url + 'programPurchaseConfirm', data)
            .then((res) => {
                let result = res.data
                alert('Program purchase successful.')
                this.setState({loading: false})
            }).catch((error) => {
                console.log(error)
                this.ProgramPurchaseSuccessful()
            })
        }
    }

    componentDidMount() {
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('plan_id', this.props.match.params.plan_id)
  
        axios.post(Backend_Url + 'getFitnessPlanCatalogueData', data)
        .then((res) => {
            let result = res.data
            this.setState({fitness_plan: result, loading: false})
        }).catch((error) => {
            console.log(error)
        })
    }

    render() {
        var fitness_plan = this.state.fitness_plan
        if(this.state.loading == true){
            return<div style={{minHeight: '550px'}}>
                <Helmet>
                <title>VIEW FITNESS PLAN - ONFIT</title>
                {/* <meta name="description" content="" /> */}
                </Helmet>
                <br/>
                <Container>
                    <br/>
                    <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                        ONFIT
                    </h1>
                    <br/><br/>
                    <Triangle
                        color="#1FACED"
                        height={130}
                        width={130}
                    />
                    <h3 style={{marginTop: '50px'}}>
                    Loading...
                    </h3>
                    <h6 style={{marginTop: '50px'}}>
                        Taking too long to load? Check your internet connection and reload the page.
                    </h6>
                    <br/><br/>
                </Container>
            </div>
        }
      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>VIEW FITNESS PLAN - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <br/>
            <Container style={{marginTop: '30px'}}>
              <Row>
                <Col sm='6'>
                    <img src={Backend_Url + 'media/' + fitness_plan.image} style={{width: '100%'}}/>
                </Col>
                <Col sm='6'>
                    <h5 style={{textAlign: 'center', marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#666', fontWeight: '700'}}>
                        {fitness_plan.name}
                    </h5>
                    <h4 style={{textAlign: 'center', marginTop: '40px', fontSize: '20px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                        {fitness_plan.category}
                    </h4>
                    <p style={{marginTop: '50px', textAlign: 'left'}}>
                        {fitness_plan.description}
                    </p>
                    <h5 style={{marginTop: '10px', fontSize: '16px', height: '18px', lineHeight: '18px', color: '#333', fontWeight: '700'}}>
                        €{fitness_plan.price}
                    </h5>
                    <br/>
                    Pay for plan
                    <br/>
                    <StripeCheckout price={fitness_plan.price} origin='program' ProgramPurchaseSuccessful={this.ProgramPurchaseSuccessful}/>
                    <br/><br/>
                </Col>
              </Row>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(FitnessPlan);